export default __webpack_public_path__ + "static/media/handwash-img.80c142ed.png";